import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import makeAnimated from 'react-select/animated';
import { addState } from 'slices/stateSlice';
import { updateState } from 'slices/stateSlice';
import { fetchStates } from 'slices/stateSlice';
import toast from 'react-hot-toast';
import { stateSelector } from 'slices/stateSlice';
import { setError } from 'slices/stateSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';

const AddStateForm = ({ item, handleClose, callback, statusPerm }) => {
  const animatedComponents = makeAnimated();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    name: '',
    status: 1,
  })
  const { error, loader } = useSelector(stateSelector);


  useEffect(() => {

    if (item?.id)
      setFormValues({
        name: item?.name || "",
        status: item?.status
      })


    dispatch(setError({}))
    return () => {

      setFormValues({
        ...formValues,
        name: "",
        status: 1
      });
      // Clean up on unmount
      // This is where you would dispatch an action to remove the hospital from the store
    }

  }, [item])

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  }

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchStates())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateState(formValues, item?.id, submitCallback));
    } else
      dispatch(addState(formValues, submitCallback));

  }

  console.log("error", error)

  return (
    <div>
      <form onSubmit={handleSubmit}>


        <div className="row-primary">
          <h2>State Name *</h2>
          <input onChange={handleChange}
            required name="name"
            className="input-in type_inp"
            type="text"
            placeholder='State Name'
            value={formValues.name}
          />
        </div>
        {statusPerm &&
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <CustomSwitch
              labelText="active"
              checked={formValues.status == 1 ? true : false}
              handleChange={(checked) => setFormValues({
                ...formValues,
                status: checked ? 1 : 0
              })}

            />
          </div>
        }

        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
            loader={loader}
          />
        </div>
      </form >

    </div >
  )
}

const AddState = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} State</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddStateForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddState
